var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[("brutalism-icon mdi mdi-" + _vm.icon), _vm.url.length ? 'link' : ''],style:({ 
		'font-size': _vm.size, 
		width: _vm.size, 
		color: _vm.color
	}),on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }